$(document).ready(function () {
    window.editConsent = $.TemplateMaster.EditConsent;
});
